import React from "react";
// material
import { Breakpoint, Theme, useMediaQuery } from "@mui/material";

interface Props {
  children?: React.ReactNode;
  width?:
    | "xsDown"
    | "smDown"
    | "mdDown"
    | "lgDown"
    | "xlDown"
    | "xsUp"
    | "smUp"
    | "mdUp"
    | "lgUp"
    | "xlUp";
}

export default function MHidden({ width, children }: Props): JSX.Element {
  const breakpoint = width.substring(0, 2);

  const hiddenUp = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up(breakpoint as Breakpoint)
  );
  const hiddenDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(breakpoint as Breakpoint)
  );

  if (width.includes("Down")) {
    return hiddenDown ? null : (children as JSX.Element);
  }

  if (width.includes("Up")) {
    return hiddenUp ? null : (children as JSX.Element);
  }

  return null;
}
